import { ViewBooking } from "collins-js-sdk";
import { DiaryContextType } from "../../context/DiaryContext";
import { editBooking, saveBooking } from "./UpdateBooking";

type updateUnsavedBookingsProps = {
  diaryContext: DiaryContextType;
};
export const updateUnsavedBookings = async ({
  diaryContext
}: updateUnsavedBookingsProps): Promise<boolean> => {
  const bookingsToSave = diaryContext.bookings?.filter(
    (booking: ViewBooking & editBooking) => booking.unsaved
  );

  if (!bookingsToSave) {
    return false;
  }

  const promiseAll = bookingsToSave?.map((booking: ViewBooking & editBooking) =>
    saveBooking(booking)
  );

  if (promiseAll) {
    await Promise.all(promiseAll);
  }

  const bookings = diaryContext.bookings?.map((booking) => ({
    ...booking,
    unsaved: false
  }));
  diaryContext.setDiaryContext({ bookings });

  return true;
};
